export default __webpack_public_path__ + "static/media/blog6.b455045f.jpg";